export const CustomSwitchStyles = (theme, isChecked) => ({
  checkbox: {
    boxSizing: 'border-box',
    opacity: 0,
    position: 'absolute',
  },
  checkSwitchFocus: {
    '&:focus-within': {
      border: `2px solid ${theme?.palette?.primary?.main}`,
      width: 'max-content',
    },
  },
  disableCursor: {
    cursor: 'default !important',
  },
  label: {
    boxSizing: 'border-box',
    backgroundColor: isChecked
      ? theme?.palette?.orientalPrimary?.main
      : theme?.palette?.switchOffBackground?.main,
    outline: `0.81px solid ${isChecked ? theme?.palette?.orientalPrimary?.main : '#d0d0d0'}`,
    borderRadius: '81.25px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px',
    position: 'relative',
    height: '27px',
    width: '47.67px',
    transition: 'background-color 0.5s linear',
  },
  labelStatement: {
    boxSizing: 'border-box',
    backgroundColor: isChecked
      ? theme?.palette?.orientalPrimary?.main
      : theme?.palette?.secondary?.main,
    outline: `0.81px solid ${isChecked ? theme?.palette?.orientalPrimary?.main : '#d0d0d0'}`,
    borderRadius: '81.25px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px',
    position: 'relative',
    height: '27px',
    width: '47.67px',
    transition: 'background-color 0.5s linear',
  },
  ball: {
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    borderRadius: '50%',
    position: 'absolute',
    top: '2px',
    left: '2px',
    height: '22.75px',
    width: '22.75px',
    transform: isChecked ? 'translateX(21px)' : 'translateX(0)',
  },

  on: {
    boxSizing: 'border-box',
    color: '#FFFFFF',
    fontWeight: 700,
    fontSize: '10px',
  },
  off: {
    boxSizing: 'border-box',
    color: theme?.palette?.subtext?.main,
    fontWeight: 700,
    fontSize: '10px',
  },
  switchMobMargin: {
    '@media screen and (max-width: 650px)': {
      margin: '10px 0px',
    },
  },
});
